import React, { Context, useEffect } from 'react';
import {
  useEventTrackerContext,
  useAuthContext,
  useSnackbarContext,
  useOnboardingContext,
} from '.';
import {
  googleSignInAfterSignUp,
  saveDataAfterGoogleSignUp,
  COMPLETED_GOOGLE_SIGNUP_KEY,
  GOOGLE_SIGNUP_ERROR,
  URL_PARAMS_ON_SIGNUP,
  GET_STARTED_DATA_KEY,
  GOOGLE_SIGNIN_KEY,
} from '../utils';

export const GoogleContext: Context<object> = React.createContext(null);

export function GoogleProvider({ children }) {
  const snackbar = useSnackbarContext();
  const { trackEvent } = useEventTrackerContext();
  const { signedIn } = useAuthContext();
  const { hasCompletedOnboarding, activeStep } = useOnboardingContext();

  async function handleGoogleSignUpComplete() {
    // MUST SAVE DATA AFTER SIGN UP THEN SIGN IN
    const completedSignUp = localStorage.getItem(COMPLETED_GOOGLE_SIGNUP_KEY);
    if (completedSignUp) {
      saveDataAfterGoogleSignUp(trackEvent);
    }
  }

  function handleGoogleSignInAfterSignUp() {
    // HANDLES SIGN IN AFTER SIGN UP
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error_description');
    if (error?.includes(GOOGLE_SIGNUP_ERROR)) {
      googleSignInAfterSignUp(snackbar, params);
    }
  }

  useEffect(() => {
    handleGoogleSignInAfterSignUp();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (signedIn) {
      handleGoogleSignUpComplete();
    }
    // eslint-disable-next-line
  }, [signedIn]);

  useEffect(() => {
    // ENSURE FOR GOOGLE THAT SIGNUP DATA IS SAVED
    const didGoogleSignin = localStorage.getItem(GOOGLE_SIGNIN_KEY);
    if (signedIn && !hasCompletedOnboarding && didGoogleSignin) {
      const urlParams = localStorage.getItem(URL_PARAMS_ON_SIGNUP);
      const getStartedData = localStorage.getItem(GET_STARTED_DATA_KEY);
      if (urlParams || getStartedData) {
        saveDataAfterGoogleSignUp(trackEvent);
      }
    }
    // eslint-disable-next-line
  }, [signedIn, hasCompletedOnboarding, activeStep]);

  return (
    <GoogleContext.Provider value={null}>{children}</GoogleContext.Provider>
  );
}
